// OpenAI service configuration and helper functions
let openaiInstance: any = null
let systemPrompt: string =
  "You are a helpful catalog assistant. Help users find products they're looking for by asking questions and making recommendations. Always format product recommendations with Markdown links and include prices."
export const initializeOpenAI = (apiKey: string, customPrompt?: string) => {
  if (customPrompt) {
    systemPrompt = customPrompt
  }
  openaiInstance = {
    apiKey,
    systemPrompt,
  }
}
export const getOpenAIInstance = () => {
  if (!openaiInstance) {
    throw new Error('OpenAI has not been initialized with an API key')
  }
  return openaiInstance
}
export const generateCatalogResponse = async (
  messages: any[],
): Promise<string> => {
  const openai = getOpenAIInstance()
  try {
    // Format messages for OpenAI API
    const formattedMessages = [
      {
        role: 'system',
        content: systemPrompt,
      },
      // Convert the conversation history to OpenAI format
      ...messages.map((msg) => ({
        role: msg.type === 'user' ? 'user' : 'assistant',
        content: msg.content,
      })),
    ]
    // Make API call to OpenAI
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${openai.apiKey}`,
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo',
        messages: formattedMessages,
        temperature: 0.7,
        max_tokens: 800,
      }),
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(
        `OpenAI API error: ${errorData.error?.message || response.statusText}`,
      )
    }
    const data = await response.json()
    return data.choices[0].message.content
  } catch (error) {
    console.error('Error generating response:', error)
    throw new Error(`Failed to generate catalog response: ${error.message}`)
  }
}
